
export const hashCode = (text: string) => {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
        const char = text.charCodeAt(i);
        hash = ((hash<<5)-hash)+char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};

export function delay(milliseconds: number, v: any = undefined) {
    return new Promise((resolve) => {
        setTimeout(resolve.bind(null, v), milliseconds)
    });
}

export function chunkArrayInGroups<T>(arr: T[], size: number): T[][] {
    let myArray = [];
    for(let i = 0; i < arr.length; i += size) {
        myArray.push(arr.slice(i, i+size));
    }
    return myArray;
}

export function toQueryString(obj: any): string {
    return Object
        .keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');
}

export function filterObj(obj: any, allowedKeys: string[]): any {
    return Object.keys(obj)
        .filter(key => allowedKeys.includes(key))
        .reduce((res: any, key: string) => {
            res[key] = obj[key];
            return res;
        }, {});
}

export function pageLoaded() {
    setTimeout(() => {
        // @ts-ignore
        window.prerenderReady = true;
    }, 3000);
}

// Splitting the array in 3 arrays
export function chunk(array: any[], size: number) {
    const chunked_arr = [];
    for (let i = 0; i < array.length; i++) {
        const last = chunked_arr[chunked_arr.length - 1];
        if (!last || last.length === size) {
            chunked_arr.push([array[i]]);
        } else {
            last.push(array[i]);
        }
    }
    return chunked_arr;
}

export function escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export default function hexToRgb(hex: string) {
    var bigint = parseInt(hex.split('#')[1], 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;

    return r + "," + g + "," + b;
}

export function fixProfessorName(name: string) {
    if(name.toLowerCase() === "ioannis kallinikos") {
        return "Jannis Kallinikos";
    } else if(name.toLowerCase() === "tatiana-alina pippidi") {
        return "Alina Mungiu-Pippidi";
    }

    return initCaps(name);
}

export function initCaps(s: string) {
    if(!s) {
        return s;
    }

    return s.toLowerCase().replace(/(?:^|\s)[a-z]/g, function (m) {
       return m.toUpperCase();
    });
 };

 export function initCap(s: string) {
    if(!s) {
        return s;
    }

    return s.charAt(0)
            .toUpperCase() + s.toLowerCase().slice(1);
 };

 export function replaceComponentsCachedUrl(url: string) {
    if(!url) {
        return url;
    }
    // check if the location's domain ends in .it or .edu
    var domain = window.location.hostname;
    var suffix = domain.substring(domain.length - 4, domain.length);
    // get the protocol
    var protocol = window.location.protocol;
    
    let base_url = protocol + '//' + domain;
    if(base_url.indexOf('localhost') > 0){
        base_url = 'https://www.luiss.it';
    }
    
    return url.replace('https://ho4out7of9.execute-api.eu-west-1.amazonaws.com/prod', base_url);
 }

 export function replaceImagesCachedUrl(data: any) {
    if(!data) {
        return data;
    }
    // check if the location's domain ends in .it or .edu
    var domain = window.location.hostname;
    var suffix = domain.substring(domain.length - 4, domain.length);
    // get the protocol
    var protocol = window.location.protocol;
    
    let base_url = protocol + '//' + domain;
    if(base_url.indexOf('localhost') > 0){
        base_url = 'https://www.luiss.it';
    }
    
    let jsonData = JSON.stringify(data).replace(/https:\/\/ho4out7of9.execute-api.eu-west-1.amazonaws.com\/prod\/sites\/default\/files/g, base_url + '/sites/default/files');
    
    // add to all the images inside the payload a "defer"
    console.log('before', jsonData);
    jsonData = addDeferToImages(jsonData);
    console.log('after', jsonData)
    data = JSON.parse(jsonData);

    return data;
 }

 function addDeferToImages(htmlString: string) {
    return htmlString.replace(/<img\b(.*?)>/g, '<img$1 defer>');
}